import { MessageSeverity } from "~app/common/components/message-panel/message-panel.models";

export interface IHandelseViewModel {
    id: number;
    linkName: string;
    subEntityId?: number;
    subEntityLinkName: string;
    subEntityType: string;
    isArbetsorder: boolean;
    message: string;
    errorDate: string;
    severity: MessageSeverity;
    aoStatus?: string;
    scheduled?: string;
    relatedArbetsordrar: IVirkeskopshandelseArbetsorder[];
}

export interface IVirkeskopshandelseArbetsorder {
    id?: number;
    linkName?: string;
}

export class SeverityFilterViewModel {
    antal = 0;

    constructor(readonly severity: MessageSeverity, private readonly label: string, public selected: boolean) {
    }

    get text() { return `${this.label} (${this.antal})`; }
}
